import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import Loader from "../components/Loader";
import CreateMember from "../components/createMember";
import { getMembersWithNoPlans } from "../services/apiServices.js";
import srcImg from "./../components/images/search.svg";
import { MDBChip } from 'mdb-react-ui-kit';
import PageError from "../views/PageError";

const GuestPassMembers = ({ props, handleform, onAdd, alreadyadded = [] }) => {
    const [searchQuery, setSearchQuery] = useState(null);
    const searchQueryRef = useRef(searchQuery);
    const containerRef = useRef();
    const [error, setError] = useState({});
    const searchRef = useRef();
    const tpageRef = useRef(0);
    const [userData, setData] = useState([]);
    const [innerLoading, setInnerLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [selectedMembers, setselectedMembers] = useState([]);
    const [showNMember, setshowNMember] = useState(false);
    const [apiError, setApiError] = useState(false);

    // Initialize selected members from props
    useEffect(() => {
        if (alreadyadded && alreadyadded.length > 0) {
            setselectedMembers(alreadyadded);
        } else {
            setselectedMembers([]);
        }
    }, [alreadyadded]);

    const showNewMember = (e) => {
        e.preventDefault();
        setshowNMember(true);
        if (handleform) handleform();
    };

    const handleToggleform = () => {
        if (handleform) handleform();
    };

    const hideCreateMember = (e, memInfo) => {
        if (memInfo) {
            selectedMembers.forEach((item) => {
                addMember(e, item, false);
                const nusers = usersData.length > 0 && usersData.filter((uitem) => uitem._id !== item._id);
                setData([item, ...nusers]);
            });
            addMember(e, memInfo, false);
            setData([memInfo, ...usersData]);
        }
        setshowNMember(false);
        if (handleform) handleform();
    };

    const addMember = (e, member, isAlreadySelected) => {
        try {
            e.preventDefault();
            e.stopPropagation();

            let ischecked = isAlreadySelected ? false : true;

            if (ischecked) {
                setselectedMembers(prev => [...prev, member]);
            } else {
                setselectedMembers(prev => prev.filter(item => item._id !== member._id));
            }
        } catch (e) {
            console.log("Error adding member: " + e);
        }
    };

    const handleScroll = () => {
        if (containerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

            if (scrollTop + clientHeight >= scrollHeight - 200 && !loading && !innerLoading) {
                setInnerLoading(true);
                fetchData();
            }
        }
    };

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
            return () => {
                container.removeEventListener("scroll", handleScroll);
            };
        }
    }, [loading]);

    const [typingTimeout, setTypingTimeout] = useState(0);

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchQuery(value);
        tpageRef.current = 0;
        setData([]);
        setLoading(true);

        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        setTypingTimeout(
            setTimeout(() => {
                fetchData();
            }, 500)
        );
    };

    useEffect(() => {
        searchQueryRef.current = searchQuery;
        return () => clearTimeout(typingTimeout);
    }, [searchQuery, typingTimeout]);

    async function fetchData() {
        if (!localStorage.getItem("loggedUserInfo")) return;

        const search = searchQueryRef.current?.trim() || null;
        const currentPage = tpageRef.current + 1;
        tpageRef.current = currentPage;

        try {
            const response = await getMembersWithNoPlans(
                JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
                currentPage,
                search,
            );

            if (!response) return;

            if (response === "false") {
                setApiError(true);
                return;
            }

            const usersData = await response.json();

            setData(prevData => {
                const existingIds = new Set(prevData.map(user => user._id));
                const uniqueUsers = usersData.filter(user => !existingIds.has(user._id));
                const sortedData = [...prevData, ...uniqueUsers].sort((a, b) => b.mid - a.mid);
                return sortedData;
            });

            setLoading(false);
            setInnerLoading(false);

        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
            setInnerLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (searchRef.current) {
            searchRef.current.focus();
        }
    }, []);

    const handleRemoveMember = (member) => {
        setselectedMembers(prev => prev.filter(m => m._id !== member._id));
    };

    const handleDone = (e) => {
        e.preventDefault();

        if (selectedMembers.length === 0) {
            setError({ nousers: "No member selected" });
            return;
        }

        onAdd(selectedMembers);
    };

    const MemberDetails = ({ member }) => (
        <MDBChip closeIcon onDelete={() => handleRemoveMember(member)}>
            {member.fname} {member.lname}
        </MDBChip>
    );

    const usersData = userData;

    return (
        <>
            {apiError ? (
                <PageError handleReload={() => window.location.reload()} />
            ) : (
                <div className="gym-main p-0 rightContent">
                    {!showNMember ? (
                        <>
                            {/* Header with search - exact match to original */}
                            <div className="gym-container" id="showcase">
                                <h6 className="gym-xlarge gym-text-red addmembersearch">
                                    {error.nousers && (
                                        <p className="clr-red" style={{ textAlign: "center" }}>
                                            {error.nousers}
                                        </p>
                                    )}
                                    <input
                                        type="text"
                                        ref={searchRef}
                                        className="gym-input forminput"
                                        placeholder="Search"
                                        value={searchQuery || ""}
                                        onChange={handleSearchChange}
                                    />
                                    <img
                                        src={srcImg}
                                        width="20px"
                                        className="searchicon"
                                        alt="Search"
                                    />
                                </h6>
                            </div>

                            {/* Selected members chips - exact match to original */}
                            <div className="d-flex flex-wrap mb-2">
                                {selectedMembers.map(member => (
                                    <MemberDetails key={member._id} member={member} />
                                ))}
                            </div>

                            {/* Loading state */}
                            {loading && (
                                <h4>
                                    <Loader />
                                </h4>
                            )}

                            {/* Members list - exact match to original styling */}
                            <div className="mainbox dynscrolll" ref={containerRef}>
                                <div className="mainboxsecond mt-12">
                                    {!loading && (
                                        <>
                                            {usersData && usersData.length > 0 ? (
                                                usersData.map((data, index) => (
                                                    !data.issuspend && (
                                                        <a
                                                            href="#"
                                                            className="ml20 pd_0"
                                                            style={{ width: "47%" }}
                                                            key={data._id}
                                                            onClick={(e) => addMember(
                                                                e,
                                                                data,
                                                                selectedMembers.some(item => item._id === data._id)
                                                            )}
                                                        >
                                                            <div
                                                                className="row usercar-prev"
                                                                onClick={(e) => addMember(
                                                                    e,
                                                                    data,
                                                                    selectedMembers.some(item => item._id === data._id)
                                                                )}
                                                            >
                                                                <div className="d-flex space-between">
                                                                    <div className="add-numbr-clr">
                                                                        <h6 className="mb-1">
                                                                            {data.fname} {data.lname}
                                                                        </h6>
                                                                        <div>
                                                                            {"Mid: "}{data.mid}
                                                                            {data.sex || data.gender ? `, ${data.sex || data.gender}` : ''}
                                                                            {(data.sex || data.gender) && (data.age || data.weight || data.number) ? ", " : ""}
                                                                            {data.age ? `${data.age}y` : ''}
                                                                            {data.age && (data.weight || data.number) ? ", " : ""}
                                                                            {data.weight ? `${data.weight}kgs` : ''}
                                                                            {data.weight && data.number ? "," : ""}
                                                                            {data.number || ''}
                                                                        </div>
                                                                    </div>

                                                                    <div>
                                                                        <div
                                                                            style={{ zIndex: 2 }}
                                                                            className="user-prev-details"
                                                                            onClick={(e) => addMember(
                                                                                e,
                                                                                data,
                                                                                selectedMembers.some(item => item._id === data._id)
                                                                            )}
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={selectedMembers.some(item => item._id === data._id)}
                                                                                id={`checkbox_useradd_${index}`}
                                                                                onChange={() => { }} // Handled by parent div click
                                                                            />
                                                                            <label htmlFor={`checkbox_useradd_${index}`}></label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="pt-1 clr-black">
                                                                    <span className="add-mbrs-span">Plan: </span>
                                                                    <span >No Active Plan</span>
                                                                    <br />
                                                                    <span className="add-mbrs-span">Addons:</span>{" "}
                                                                    {data.addons && data.addons.length > 0
                                                                        ? data.addons[0].name
                                                                        : "No Addon(s)"}
                                                                </div>
                                                            </div>
                                                        </a>
                                                    )
                                                ))
                                            ) : (
                                                <div>No members found</div>
                                            )}
                                        </>
                                    )}
                                </div>

                                {innerLoading && (
                                    <div className="mx-auto">
                                        <span className="spinner-border spinner-border-md clr-green" role="status">
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* Footer buttons - exact match to original */}
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-mdb-dismiss="modal"
                                    onClick={showNewMember}
                                >
                                    Add New Member
                                </button>
                                &nbsp;&nbsp;
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-mdb-dismiss="modal"
                                    onClick={handleDone}
                                >
                                    Done
                                </button>
                            </div>
                        </>
                    ) : (
                        <CreateMember
                            id={props?.id}
                            index={props?.index}
                            onsubmit={() => { }}
                            submit={props?.submit}
                            backallback={hideCreateMember}
                            path={"membership"}
                            gymid={JSON.parse(localStorage.getItem("loggedUserInfo")).gymid}
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default GuestPassMembers;